import Flickity from "flickity";

const IconGridSlider = (slides) => {

    var slider = new Flickity(slides, {
        adaptiveHeight: false,
        cellAlign: 'left',
        contain: false,
        pageDots: false,
        prevNextButtons: false,
        watchCSS: true
    });

}

export default IconGridSlider;